/** Ticket currently open in Support while the tab is visible. */
let focusedTicketId = null;

export function setFocusedSupportTicket(ticketId) {
  focusedTicketId = ticketId || null;
}

export function getFocusedSupportTicket() {
  return focusedTicketId;
}

/**
 * Suppress in-app push/toast when the user is looking at that ticket's chat.
 */
export function shouldSuppressSupportNotification({
  url,
  entityId,
  ticketId,
  data,
} = {}) {
  if (!focusedTicketId) return false;
  if (typeof document !== "undefined" && document.visibilityState !== "visible") {
    return false;
  }

  if (ticketId && ticketId === focusedTicketId) return true;
  if (entityId && entityId === focusedTicketId) return true;
  if (data?.ticketId && data.ticketId === focusedTicketId) return true;

  const href = String(url || data?.url || "");
  if (href.includes(`ticket=${focusedTicketId}`)) return true;

  return false;
}
